<template>
  <div class="mx-auto container container--fluid">
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <v-data-table v-if="load == true" :headers="headers" :items="item_list" id="my-table-id" sort-by="standard"
        class="elevation-1 mytable" dense :search="search" :items-per-page="-1">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Items</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row>
            <v-col cols="12" sm="2" md="2">
              <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'Item')"><v-icon
                  color="success">mdi-export</v-icon>Export</v-btn>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line
                hide-details></v-text-field>
            </v-col>
            <v-dialog v-model="dialog" max-width="800px">
              <template v-slot:activator="{ on }">
                <v-btn class="mt-4 ml-4 button" v-on="on" small>Add Item</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="4" md="4">
                          <b>Vendor</b><v-icon small class="pl-1 pb-2" color="error">*</v-icon>
                          <v-select dense v-model="editedItem.vendor" :items="vendor_list" item-text="name" outlined
                            item-value="id" persistent-hint hint="select vendor" @change="getVendorShop()"
                            :rules="[(v) => !!v || 'required']" single-line></v-select>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <b>Vendor Shop</b><v-icon small class="pl-1 pb-2" color="error">*</v-icon>
                          <v-select dense v-model="editedItem.vendorShop" :items="vendorshop_list" item-text="name"
                            outlined item-value="id" persistent-hint hint="select vendor shop"
                            :rules="[(v) => !!v || 'required']" single-line></v-select>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <b>Item Category</b><v-icon small class="pl-1 pb-2" color="error">*</v-icon>
                          <v-select dense v-model="editedItem.itemcategory" :items="item_category_list" item-text="name"
                            outlined persistent-hint hint="select item category" item-value="id"
                            @change="getitemcategorydata()" :rules="[(v) => !!v || 'required']" single-line></v-select>
                        </v-col>

                        <v-col cols="12" sm="6" md="6">
                          <b>Item Code</b><v-icon small class="pl-1 pb-2" color="error">*</v-icon>
                          <v-text-field v-model="editedItem.itemcode" outlined dense persistent-hint
                            :rules="[(v) => !!v || 'required']" hint="For e.g.12345..."></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <b>Item Name</b><v-icon small class="pl-1 pb-2" color="error">*</v-icon>
                          <v-text-field v-model="editedItem.itemname" outlined dense persistent-hint
                            :rules="[(v) => !!v || 'required']"
                            hint="For e.g.Stationary kit 1, Stationary kit 2, ..."></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <b>Item Description</b>
                          <v-textarea class="mt-2" outlined name="input-7-4" v-model="editedItem.itemdescription"
                            label="Enter Item Description"></v-textarea></v-col>
                        <v-col cols="12" sm="6" md="6">
                          <b>ISBN</b><v-icon small class="pl-1" color="error"></v-icon>
                          <v-text-field v-model="editedItem.isbn" outlined dense persistent-hint
                            hint="For e.g. 9780596520687..."></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <b>Base Price</b><v-icon small class="pl-1 pb-2" color="error">*</v-icon>
                          <v-text-field min="0" type="number" v-model="editedItem.baseprice" outlined dense
                            persistent-hint :rules="[(v) => !!v || 'required']" @wheel.prevent></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <b>Tax</b><v-icon small class="pl-1 pb-2" color="error">*</v-icon>
                          <v-text-field min="0" type="number" v-model="editedItem.tax" outlined dense persistent-hint
                            :rules="[(v) => v === 0 || !!v || 'required']"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <b>Total Price</b><v-icon small class="pl-1 pb-2" color="error">*</v-icon>
                          <v-text-field type="number" min="0" clearable v-model="editedItem.totalprice" outlined dense
                            persistent-hint :rules="[(v) => !!v || 'required']"></v-text-field>
                        </v-col>
                        <v-col ccols="12" sm="6" md="6">
                          <b>Product Image</b>
                          <v-file-input class="mt-2" v-model="itemimage" label="Upload Product Image"
                            prepend-icon="mdi-paperclip" dense rounded outlined>
                          </v-file-input>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <b>Standard </b>
                          <v-icon small class="pl-1 pb-2" color="error">*</v-icon>
                          <v-select dense v-model="editedItem.itemStandardlist" class="mt-2" :items="standard_list"
                            item-text="standardname" outlined item-value="standardid"
                            :rules="[(v) => (v && v.length > 0) || 'required']" multiple>
                            <template v-slot:prepend-item>
                              <v-list-item>
                                <v-checkbox @change="
                                    togglemethod(editedItem.itemStandardlist)
                                  " v-model="selected_toggle"></v-checkbox>

                                <v-list-item-content>
                                  <v-list-item-title>
                                    Select All
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-divider class="mt-2"></v-divider>
                            </template>
                          </v-select>
                        </v-col>
                      </v-row>
                      <v-row v-if="editedItem.is_size_applicable == true">
                        <v-col cols="12" sm="6" md="6">
                          <b>Size Lable Type</b><v-icon small class="pl-1 pb-2" color="error">*</v-icon>
                          <v-select dense v-model="editedItem.sizelabeltype" :items="size_label_type_list"
                            item-text="name" outlined item-value="id" @change="getsizelabletypedata()" single-line
                            :rules="[(v) => !!v || 'required']"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <b>Size Lable </b><v-icon small class="pl-1 pb-2" color="error">*</v-icon>
                          <v-select dense v-model="editedItem.sizelabel" :items="size_label_list" item-text="name"
                            outlined item-value="id" :rules="[(v) => !!v || 'required']" single-line></v-select>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <b>Size Chart </b>
                          <v-file-input class="mt-2" v-model="sizechartfile" label="Upload Size Chart"
                            prepend-icon="mdi-paperclip" dense rounded outlined>
                          </v-file-input>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <b>Size Description</b>
                          <v-textarea class="mt-2" outlined name="input-7-4" v-model="editedItem.sizechartdescription"
                            label="Enter Size Description"></v-textarea>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" @click="save" :disabled="!valid" :loading="save_loader">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
            <v-col cols="12" sm="3" md="3">
              <v-btn class="mt-1" rounded color="success" small tile @click="opendialogbox()">
                <v-icon class="mr-2" small>mdi-file-import</v-icon>import Excel
              </v-btn>
            </v-col>
          </v-row>
        </template>

        <template v-slot:[`item.is_size_applicable`]="{ item }">
          <v-icon v-if="item.is_size_applicable" color="success">mdi-check-circle-outline</v-icon>
          <v-icon v-else color="red">mdi-close-circle-outline</v-icon>
        </template>

        <template v-slot:[`item.isactive`]="{ item }">
          <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
            @change="toggle(item)"></v-switch>
        </template>
        <template v-slot:[`item.itemdescription`]="{ item }">
          <v-icon v-if="item.itemdescription" @click="openDescDialog(item.itemdescription)" class="cursor-pointer"
            color="info">mdi-eye</v-icon>
          <span v-else>--</span>
        </template>
        <template v-slot:[`item.sizechartdescription`]="{ item }">
          <span style="color: grey" v-if="item.sizechartdescription == '--'">--</span>
          <v-icon v-else @click="opensizeDescDialog(item.sizechartdescription)" class="cursor-pointer"
            color="info">mdi-eye</v-icon>
        </template>
        <template v-slot:[`item.itemimage`]="{ item }">
          <span v-if="item.itemimage == '-'">--</span>
          <span v-else>
            <v-icon color="info" class="cursor-pointer" @click="viewImage(item.itemimage,item.contains_http)">
              visibility
            </v-icon>
          </span>
        </template>
        <template v-slot:[`item.sizechart_file`]="{ item }">
          <span v-if="item.sizechart_file == '-'">--</span>
          <span v-else>
            <v-icon color="info" class="cursor-pointer" @click="viewImage(item.sizechart_file,item.contains_http)">
              visibility
            </v-icon>
          </span>
        </template>
        <template v-slot:[`item.sizelabeltype`]="{ item }">
          <span style="color: grey" v-if="item.is_size_applicable == false">--</span>
          <span v-else>{{ item.sizelabeltype.name }}</span>
        </template>
        <template v-slot:[`item.sizelabel`]="{ item }">
          <span style="color: grey" v-if="item.is_size_applicable == false">--</span>
          <span v-else>{{ item.sizelabel.name }}</span>
        </template>
        <template v-slot:[`item.itemStandardlist`]="{ item }">
          <span>
            <span v-for="(i, index) in item.itemStandardlist" :key="index">
              <span v-if="index !== 0" style="margin-left: 3px">,</span>
              <span style="margin-left: 3px">{{ i.standardname }}</span>
            </span>
          </span>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-avatar style size="25" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)" title="edit" style>edit</v-icon>
          </v-avatar>
        </template>
        <template v-slot:[`item.delete`]="{ item }">
          <v-avatar size="25" class="edit-avatar">
            <v-icon class="v-icon-size" color="red" @click="deleted(item)">mdi-trash-can</v-icon>
          </v-avatar>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="descDialog" max-width="700">
      <v-card>
        <v-card-title class="toolbar">Item Description <v-spacer></v-spacer><v-icon color="white"
            @click="closeDescDialog">mdi-close</v-icon></v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-0 pr-2">
          <v-row justify="center" no-gutters>
            <v-col cols="12" sm="12" md="12" class="pb-6 pt-3" align="center">
              <b style="font-size: 17px"> {{ selectedDescription }} </b>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="sizedescDialog" max-width="700">
      <v-card>
        <v-card-title class="toolbar">Size Chart Description <v-spacer></v-spacer><v-icon color="white"
            @click="closesizeDescDialog">mdi-close</v-icon></v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-0 pr-2">
          <v-row justify="center" no-gutters>
            <v-col cols="12" sm="12" md="12" class="pb-6 pt-3" align="center">
              <b style="font-size: 17px"> {{ selsizedescription }} </b>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog1" max-width="900px" fullscreen>
      <v-card class="box">
        <v-toolbar dense class="toolbar" flat color="white">
          <v-toolbar-title>Import Item</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog1 = false; file = null">
            <v-icon large>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-toolbar>

        <v-row dense justify="end">
          <v-col cols="12" sm="3" md="3" align="right" class="mr-4">
            <a href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/csv_files/import_item.csv">
              <v-btn color="success" rounded outlined>
                Download CSV format
                <v-icon right dark>mdi-file-download</v-icon>
              </v-btn>
            </a>
          </v-col>
        </v-row>
        <v-row dense justify="center" class="mt-10">
          <v-col cols="12" sm="3" md="3"></v-col>
          <v-col cols="12" sm="4" md="4" class="mr-6">
            <v-file-input placeholder="Import CSV of Item" prepend-icon="mdi-file-delimited" dense flat outlined
              show-size v-model="file"></v-file-input>
          </v-col>

          <v-col cols="12" sm="3" md="3">
            <v-btn class="info" @click="submit" :loading="output_load">Submit</v-btn>
          </v-col>
        </v-row>
        <v-row dense justify="center" class="mt-10">
          <v-col sm="2">
            <div v-if="vendor_list != null">
              <v-simple-table dense class="elevation-2 mytable" v-if="vendor_list != ''">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center">Vendor</th>
                    </tr>
                  </thead>
                  <tbody class="text-center">
                    <tr v-for="(item, index) in vendor_list" :key="index">
                      <td>{{ item.name }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

            </div>
          </v-col>
          <v-col sm="2">
            <div v-if="vendorshop_list != null">
              <v-simple-table dense class="elevation-2 mytable" v-if="vendorshop_list != ''">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center">Vendor Shop</th>
                    </tr>
                  </thead>
                  <tbody class="text-center">
                    <tr v-for="(item, index) in vendorshop_list" :key="index">
                      <td>{{ item.name }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

            </div>
          </v-col>
          <v-col sm="2">
            <div v-if="item_category_list != null">
              <v-simple-table dense class="elevation-2 mytable" v-if="item_category_list != ''">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center">Item Category</th>
                    </tr>
                  </thead>
                  <tbody class="text-center">
                    <tr v-for="(item, index) in item_category_list" :key="index">
                      <td>{{ item.name }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

            </div>
          </v-col>
          <v-col sm="2">
            <div v-if="size_label_type_list != null">
              <v-simple-table dense class="elevation-2 mytable" v-if="size_label_type_list != ''">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center">Size Label Type</th>
                    </tr>
                  </thead>
                  <tbody class="text-center">
                    <tr v-for="(item, index) in size_label_type_list" :key="index">
                      <td>{{ item.name }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

            </div>
          </v-col>
          <v-col sm="2">
            <div v-if="size_label_list != null">
              <v-simple-table dense class="elevation-2 mytable" v-if="size_label_list != ''">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center">Size Label</th>
                    </tr>
                  </thead>
                  <tbody class="text-center">
                    <tr v-for="(item, index) in size_label_list" :key="index">
                      <td>{{ item.name }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

            </div>
          </v-col>
          <v-col sm="2">
            <div v-if="standard_list != null">
              <v-simple-table dense class="elevation-2 mytable" v-if="standard_list != ''">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center">Standard</th>
                    </tr>
                  </thead>
                  <tbody class="text-center">
                    <tr v-for="(item, index) in standard_list" :key="index">
                      <td>{{ item.standardname }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

            </div>
          </v-col>
        </v-row>
        <br />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    dialog1: false,
    file: null,
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    output_load: false,
    errorMsg: {    
      vendor: false,
      itemcategory: false,
      vendorShop:false,
      itemcode: false,
      itemname: false,
      isbn: false,
      itemdescription: false,
      is_size_applicable: false,
      sizelabeltype: false,
      sizelabel: false,
      sizechartfile: false,
      sizechartdescription: false,
      baseprice: false,
      totalprice: false,
      tax: false,
      itemimage: false,
      standard: false,
      isactive: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    items: [],
    dialog: false,
    search: "",

    load: false,
    headers: [
      {
        text: "Vendor",
        value: "vendor.name",
      },
      {
        text: "Vendor Shop",
        value: "vendorShop.name",
      },
      {
        text: "Item Category",
        value: "itemcategory.name",
      },
      {
        text: "Item Name",
        value: "itemname",
      },
      {
        text: "Item Code",
        value: "itemcode",
      },
      {
        text: "ISBN",
        value: "isbn",
      },
      {
        text: "Standard",
        value: "itemStandardlist",
      },
      {
        text: "Item Description",
        value: "itemdescription",
      },
      {
        text: "Product Image",
        value: "itemimage",
      },
      {
        text: "Base Price",
        value: "baseprice",
      },
      {
        text: "Tax",
        value: "tax",
      },
      {
        text: "Total Price",
        value: "totalprice",
      },

      {
        text: "Size Lable Type",
        value: "sizelabeltype",
      },
      {
        text: "Size Lable",
        value: "sizelabel",
      },
      {
        text: "Size Chart",
        value: "sizechart_file",
      },
      {
        text: "Size Description",
        value: "sizechartdescription",
      },
      { text: "Isactive", value: "isactive", sortable: false },
      { text: "Actions", value: "action", sortable: false },
      { text: "Delete", value: "delete", sortable: false },
    ],
    item_list: [],
    vendor_list: [],
    item_category_list: [],
    size_label_list: [],
    size_label_type_list: [],
    standard_list: [],
    vendorshop_list: [],
    vendor_shop_list:[],
    editedIndex: -1,
    editedItem: {
      id: "",
      vendor: "",
      vendorShop:"",
      itemcategory: "",
      itemcode: "",
      itemname: "",
      isbn: "",
      itemdescription: "",
      is_size_applicable: false,
      sizelabeltype: "",
      sizelabel: "",
      itemStandardlist: [],
      sizechartdescription: "",
      baseprice: "",
      totalprice: "",
      tax: "",

      standard: "",
      isactive: false,
    },
    sizechartfile: null,
    itemimage: null,
    defaultItem: {
      id: "",
      vendor: "",
      vendorShop:"",
      itemcategory: "",
      itemcode: "",
      itemname: "",
      isbn: "",
      itemdescription: "",
      is_size_applicable: false,
      sizelabeltype: "",
      sizelabel: "",
      itemStandardlist: [],
      sizechartdescription: "",
      baseprice: "",
      totalprice: "",
      tax: "",

      standard: "",
      isactive: false,
    },

    selectedDescription: "",
    descDialog: false,
    basepath: null,
    sizedescDialog: false,
    selsizedescription: "",
    selected_toggle: false,
    save_loader: false,
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {},
  mounted() {
    this.onload();
    this.basepath = localStorage.getItem("awspath");
  },
  methods: {
      togglemethod() {
          if (this.selected_toggle) {
              this.editedItem.itemStandardlist = this.standard_list.map(
                  (std) => std.standardid
              );
          } else {
              this.editedItem.itemStandardlist = [];
          }
      },
    fnExcelReport(id, name) {
      let tab_text = `<table border='1px'>
            <tr>
            <th>Vendor</th>
            <th>Vendor Shop</th>
            <th>Item Category</th>
            <th>Item Name</th>
            <th>Item Code</th>
            <th>ISBN</th>
            <th>Standard</th>
            <th>Item Description</th>
            <th>Product Image</th>
            <th>Base Price</th>
            <th>Tax</th>
            <th>Total Price</th>
            <th>Size label Type</th>
            <th>Size label</th>
            <th>Size Chart</th>
            <th>Size Description</th>
            <th>Is Active?</th>
            </tr>`;

      this.item_list.forEach((s) => {
        let isactive = s.isactive ? "Yes" : "No";

        let standards =
          s.itemStandardlist && s.itemStandardlist.length > 0
            ? s.itemStandardlist.map((std) => std.standardname).join(", ")
            : "--";
        tab_text += `
            <tr>                
                <td>${s.vendor.name}</td>
                <td>${s.vendorShop.name}</td>
                <td>${s.itemcategory.name}</td>
                <td>${s.itemname}</td>
                <td>${s.itemcode}</td>
                <td>${s.isbn}</td>
                <td>${standards}</td>
                <td>${s.itemdescription}</td>
                <td><a href="${s.itemimage}" target="_blank">${
          s.itemimage
        }</a></td>
                <td>${s.baseprice}</td>
                <td>${s.tax}</td>
                <td>${s.totalprice}</td>
                <td>${
                  s.sizelabeltype && s.sizelabeltype.name
                    ? s.sizelabeltype.name
                    : "--"
                }</td>
                <td>${
                  s.sizelabel && s.sizelabel.name ? s.sizelabel.name : "--"
                }</td>
                <td><a href="${s.sizechart_file}" target="_blank">${
          s.sizechart_file
        }</a></td>
                <td>${s.sizechartdescription}</td>
                <td>${isactive}</td>
            </tr>`;
      });

      tab_text += "</table>";

      const blob = new Blob([tab_text], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const filename = name + ".xls";

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    submit() {
      if (this.file == null) {
        alert("Please select the file!");
      } else {
        this.output_load = true;
        let formData = new FormData();
        formData.append("file", this.file);
        axios
          .post("EduStoreSupplier/importItems", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
              if (res.data.structure_List && res.data.structure_List.length > 0) {
                  const structureItem = res.data.structure_List[0];

                  if (structureItem.statuslist && structureItem.statuslist.length > 0) {
                      this.showSnackbar("success", structureItem.statuslist[0].reason);
                  } 
                  
                  if (structureItem.failedlist && structureItem.failedlist.length > 0) {
                      this.showSnackbar("error", structureItem.failedlist[0].reason);
                  }
                  this.file = null;
                  this.dialog1 = false;
                  this.onload();
              }
          })
          .catch(function () {
            console.log("FAILURE!!");
          })
          .finally(() => {
            this.output_load = false;
          });
      }
    },
    getVendorShop() {
      const data = {
        vendorid: this.editedItem.vendor,
      };

      axios
        .post("/EduStoreSupplier/getVendorShops", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.flag == "YES") {
            this.vendorshop_list = res.data.vendorshoplist;
            // this.item_category_list = res.data.item_category_list;
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "error",
              "Something went wrong, Please try again later!"
            );
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    onload() {
      axios
        .post("/EduStoreSupplier/getaddItem")
        .then((res) => {
          if (res.data.msg == "200") {
            this.item_list = res.data.item_list;
            this.item_category_list = res.data.item_category_list;
            this.vendor_list = res.data.vendor_list;
            this.size_label_list = res.data.size_label_list;
            this.size_label_type_list = res.data.size_label_type_list;
            this.standard_list = res.data.standard_list;
            this.vendorshop_list = res.data.vendor_shop_list;
            this.load = true;
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    initializeErrorMsgFalse() {
      this.errorMsg.name = false;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    editItem(item) {        
      this.editedIndex = this.item_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    opendialogbox() {
      this.dialog1 = true;
    },

    close() {
      this.dialog = false;
      this.initializeErrorMsgFalse();
      this.itemStandardlist = [];
      this.itemimage =null;
      this.selected_toggle=false;
      this.sizechartfile = null;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    openDescDialog(desc) {
      this.selectedDescription = desc;
      this.descDialog = true;
    },
    closeDescDialog() {
      this.selectedDescription = "";
      this.descDialog = false;
    },

    opensizeDescDialog(desc) {
      this.selsizedescription = desc;
      this.sizedescDialog = true;
    },
    closesizeDescDialog() {
      this.selsizedescription = "";
      this.sizedescDialog = false;
    },
    viewImage(imagePath,contains_http) {
      if (imagePath && !contains_http) {
        const fullImageUrl = `${this.basepath}${imagePath}`;
        window.open(fullImageUrl, "_blank");
      }else if (imagePath && contains_http) {
        const fullImageUrl = `${imagePath}`;
        window.open(fullImageUrl, "_blank");
      } else {
        console.warn("No image path provided.");
      }
    },
    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          let formData = new FormData();
          formData.append("itemname", this.editedItem.itemname);
            formData.append("itemcode", this.editedItem.itemcode);
      
            formData.append(
                "standard",
                JSON.stringify(this.editedItem.itemStandardlist.map(
                    (std) => (typeof std === "object" ? std.standardid : std)
                ))
            );
          formData.append("isbn", this.editedItem.isbn);
          formData.append("itemdescription", this.editedItem.itemdescription);
          formData.append(
            "is_size_applicable",
            this.editedItem.is_size_applicable
          );
          formData.append("baseprice", this.editedItem.baseprice);
          formData.append("totalprice", this.editedItem.totalprice);
          formData.append("tax", this.editedItem.tax);

          formData.append(
            "sizedescription",
            this.editedItem.sizechartdescription
          );
          formData.append("itemimage", this.itemimage);
          formData.append("sizechartfile", this.sizechartfile);
          formData.append(
            "vendor",
            this.editedItem.vendor &&
              typeof this.editedItem.vendor === "object" &&
              Object.hasOwn(this.editedItem.vendor, "id")
              ? this.editedItem.vendor.id
              : this.editedItem.vendor || ""
          );
          formData.append(
            "vendorShop",
            this.editedItem.vendorShop &&
              typeof this.editedItem.vendorShop === "object" &&
              Object.hasOwn(this.editedItem.vendorShop, "id")
              ? this.editedItem.vendorShop.id
              : this.editedItem.vendorShop || ""
          );
          formData.append(
            "itemcategory",
            this.editedItem.itemcategory &&
              typeof this.editedItem.itemcategory === "object" &&
              Object.hasOwn(this.editedItem.itemcategory, "id")
              ? this.editedItem.itemcategory.id
              : this.editedItem.itemcategory || ""
          );

          formData.append(
            "sizelabel",
            this.editedItem.sizelabel &&
              typeof this.editedItem.sizelabel === "object" &&
              Object.hasOwn(this.editedItem.sizelabel, "id")
              ? this.editedItem.sizelabel.id
              : this.editedItem.sizelabel || ""
          );

          formData.append(
            "sizelabeltype",
            this.editedItem.sizelabeltype &&
              typeof this.editedItem.sizelabeltype === "object" &&
              Object.hasOwn(this.editedItem.sizelabeltype, "id")
              ? this.editedItem.sizelabeltype.id
              : this.editedItem.sizelabeltype || ""
          );
          formData.append("id", this.editedItem.id);

          axios
            .post("/EduStoreSupplier/editItem", formData)
            .then((res) => {
              if (res.data.code == "SUCCESS") {              
                this.showSnackbar("#4caf50", "Item Updated Successfully..."); 
                this.onload();
                this.dialog = false;
              }
              else{
                this.showSnackbar("error", "Something went wrong..."); 
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

        //   this.close();
        }
      } else {
        if (this.isValidated()) {
          this.save_loader = true;
          let formData = new FormData();
          formData.append("itemname", this.editedItem.itemname);
          formData.append("itemcode", this.editedItem.itemcode);
          formData.append("standard", this.editedItem.itemStandardlist);
          formData.append("isbn", this.editedItem.isbn);
          formData.append("itemdescription", this.editedItem.itemdescription);
          formData.append(
            "is_size_applicable",
            this.editedItem.is_size_applicable
          );
          formData.append("baseprice", this.editedItem.baseprice);
          formData.append("totalprice", this.editedItem.totalprice);
          formData.append("tax", this.editedItem.tax);
          formData.append("itemimage", this.itemimage);

          formData.append(
            "sizedescription",
            this.editedItem.sizechartdescription
          );
          formData.append("sizechartfile", this.sizechartfile);
          formData.append(
            "vendor",
            Object.hasOwn(this.editedItem.vendor, "id")
              ? this.editedItem.vendor.id
              : this.editedItem.vendor
          );
          formData.append(
            "vendorShop",
            Object.hasOwn(this.editedItem.vendorShop, "id")
              ? this.editedItem.vendorShop.id
              : this.editedItem.vendorShop
          );
          formData.append(
            "itemcategory",
            Object.hasOwn(this.editedItem.itemcategory, "id")
              ? this.editedItem.itemcategory.id
              : this.editedItem.itemcategory
          );
          formData.append(
            "sizelabel",
            Object.hasOwn(this.editedItem.sizelabel, "id")
              ? this.editedItem.sizelabel.id
              : this.editedItem.sizelabel
          );
          formData.append(
            "sizelabeltype",
            Object.hasOwn(this.editedItem.sizelabeltype, "id")
              ? this.editedItem.sizelabeltype.id
              : this.editedItem.sizelabeltype
          );
          axios
            .post("/EduStoreSupplier/saveItem", formData)
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                this.showSnackbar("#4caf50", "Item Added Successfully..."); 
                this.onload();
                this.close();
              } else if (res.data.status.code == "NA") {
                this.showSnackbar("#b71c1c", res.data.status.message); 
                this.close();
                this.save_loader = false;
              }
            })
            .catch((error) => {
              window.console.log(error);
            })
            .finally(() => {
                this.save_loader = false;
                this.close();
            });          
        }
    }
    }, 
    isValidated() {
      if (this.editedItem.vendor) {
        return true;
      } else {
        if (!this.editedItem.vendor) {
          this.errorMsg.vendor = true;
        }
        return false;
      }
      if (this.editedItem.vendorShop) {
        return true;
      } else {
        if (!this.editedItem.vendorShop) {
          this.errorMsg.vendorShop = true;
        }
        return false;
      }

      if (this.editedItem.itemcategory) {
        return true;
      } else {
        if (!this.editedItem.itemcategory) {
          this.errorMsg.itemcategory = true;
        }

        return false;
      }
      if (this.editedItem.itemcode) {
        return true;
      } else {
        if (!this.editedItem.itemcode) {
          this.errorMsg.itemcode = true;
        }

        return false;
      }

      if (this.editedItem.itemname) {
        return true;
      } else {
        if (!this.editedItem.itemname) {
          this.errorMsg.itemname = true;
        }

        return false;
      }
      if (this.editedItem.baseprice) {
        return true;
      } else {
        if (!this.editedItem.baseprice) {
          this.errorMsg.baseprice = true;
        }

        return false;
      }
      if (this.editedItem.tax) {
        return true;
      } else {
        if (!this.editedItem.tax) {
          this.errorMsg.tax = true;
        }

        return false;
      }
      if (this.editedItem.totalprice) {
        return true;
      } else {
        if (!this.editedItem.totalprice) {
          this.errorMsg.totalprice = true;
        }

        return false;
      }

      if (
        this.editedItem.is_size_applicable == true &&
        this.editedItem.sizelabeltype
      ) {
        return true;
      } else {
        if (
          this.editedItem.is_size_applicable == true &&
          !this.editedItem.sizelabeltype
        ) {
          this.errorMsg.sizelabeltype = true;
        }

        return false;
      }

      if (
        this.editedItem.is_size_applicable == true &&
        this.editedItem.sizelabel
      ) {
        return true;
      } else {
        if (
          this.editedItem.is_size_applicable == true &&
          !this.editedItem.sizelabel
        ) {
          this.errorMsg.sizelabel = true;
        }

        return false;
      }
    }, 
    toggle(item) {
      const data = {
        active_id: item.id,
        toggle: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/EduStoreSupplier/toggleItem", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Item Status Changed successfully..."); 
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "error",
              "Something went wrong..."
            ); 
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    deleted(item) {
      if (!confirm("Are You Sure You Want To Delete ...?")) return;
      const data = {
        id: item.id,
      };
      this.overlay = true;
      axios
        .post("/EduStoreSupplier/deleteItem", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.onload();
            this.showSnackbar("#4caf50", "Item Deleted Successfully..."); 
          } else if (res.data.code == "NA") {
            this.showSnackbar("error",res.data.message); 
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    getitemcategorydata() {
      const data = {
        itemcategory_id: this.editedItem.itemcategory,
      };

      axios
        .post("/EduStoreSupplier/fetchItemcategorydata", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.editedItem.is_size_applicable = res.data.is_size_applicable;
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "error",
              "Something went wrong, Please try again later!"
            ); 
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    getsizelabletypedata() {
      const data = {
        sizelabeltype_id: this.editedItem.sizelabeltype,
      };
      axios
        .post("/EduStoreSupplier/fetchsizelabletypedata", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.size_label_list = res.data.size_label_list;
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "error",
              "Something went wrong, Please try again later!"
            ); 
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}
</style>
